import { productCatalogue, type ProductCatalogueEntry } from '../catalogue/products';

// Only a catalogue product with a real destination may be linked back to — the `from`
// parameter is caller-supplied, so it selects from the catalogue rather than providing
// a URL of its own.
export function backLinkFor(from: string | null): ProductCatalogueEntry | null {
  if (!from) return null;
  const product = productCatalogue.find((entry) => entry.key === from);
  return product?.path ? product : null;
}
